import * as d3 from 'd3';

// Create an element, clone the SVG into it and get the Boundary from there
// Used as fallback when getBBox() returns 0 because the SVG is not visibly rendered
const getWidthFallback = (svgEl) => {
  const tempDiv = document.createElement('div');
  tempDiv.setAttribute('style', 'position:absolute; visibility:hidden; width:0; height:0');
  document.body.appendChild(tempDiv);

  const tempSvg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
  tempDiv.appendChild(tempSvg);

  const tempEl = svgEl.cloneNode(true);
  tempSvg.appendChild(tempEl);

  const bb = tempEl.getBBox ? tempEl.getBBox().width : tempEl.getBoundingClientRect().width;

  document.body.removeChild(tempDiv);
  return bb;
};

const d3Helper = {
  methods: {
    getWidth(node) {
      // getBBox is slightly more accurate but not supported on IE
      const width = node.getBBox ? node.getBBox().width : node.getBoundingClientRect().width;

      return width || getWidthFallback(node);
    },
    drawNotAvailable(text = 'N/A', size = 180) {
      const svgSize = 180;

      d3.select(this.$el)
        .attr('width', size || '100%')
        .attr('height', size || '100%')
        .attr('viewBox', `0 0 ${svgSize + 2} ${svgSize + 2}`)
        .append('g')
        .attr('transform', `translate(${svgSize / 2}, ${svgSize / 2})`);

      this.drawText(text, {
        fontColor: '#666',
        x: 40,
        y: 0,
        width: svgSize - 80,
        height: svgSize,
        fontSize: 48,
      });
    },
    drawText(text, options) {
      const {
        x = 0,
        y = 0,
        width = 100,
        height = 50,
        fontSize = 36,
        fontColor = '#333',
        align = 'middle',
        debug = false,
      } = options;

      const group = d3.select(this.$el).append('g').attr('transform', 'translate(0,0)');

      if (debug) {
        group
          .append('rect')
          .attr('class', 'text-rect')
          .attr('width', width)
          .attr('height', height)
          .attr('x', x)
          .attr('y', y)
          .attr('opacity', '0.5')
          .style('fill', 'red');
      }

      group
        .append('text')
        .style('font-size', `${fontSize}px`)
        .attr('fill', fontColor)
        .style('text-anchor', align)
        .text(() => text);

      const node = group.select('text').node();
      const textWidth = this.getWidth(node);
      const scaleFactor = Math.min(1, width / textWidth);
      const fontSizeAdjusted = fontSize * scaleFactor;

      let posX = x;
      if (align === 'middle') {
        posX = width / 2 + x;
      } else if (align === 'right') {
        posX = x + width - textWidth * scaleFactor;
      }

      const posY = y + height / 2;

      group
        .select('text')
        .attr('x', posX)
        .attr('y', posY)
        .attr('dy', '0.4em')
        .style('font-size', `${fontSizeAdjusted}px`);
    },
  },
};

export default d3Helper;
